import { useEffect, useState } from 'react'
import ResellerShell from './ResellerShell'
import { tournamentApi } from '../../services/api'
import { useLanguage } from '../../context/LanguageContext'

/**
 * Reviews moderation page — Phase 10.
 * Tabs: pending (submitted, awaiting moderation) / public (published) /
 * hidden (rejected) / unsubmitted (invite sent, no rating yet).
 */
export default function Reviews() {
  const { t } = useLanguage()
  const [status, setStatus] = useState('pending')
  const [reviews, setReviews] = useState([])
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState(null)

  function reload() {
    setLoading(true); setErr(null)
    tournamentApi.get(`/portal/reseller/reviews?status=${status}`)
      .then(r => setReviews(r.data?.reviews || []))
      .catch(e => setErr(e?.response?.data?.message || e.message))
      .finally(() => setLoading(false))
  }
  useEffect(reload, [status])

  async function moderate(id, action) {
    try { await tournamentApi.patch(`/portal/reseller/reviews/${id}`, { action }); reload() }
    catch (e) { alert(e?.response?.data?.message || e.message) }
  }

  return (
    <ResellerShell title={t('sp_nav_reviews', 'Reviews')}>
      <div style={{ display: 'flex', gap: 4, background: '#fff', borderRadius: 8, padding: 4, border: '1px solid #e2e8f0', marginBottom: 16, width: 'fit-content' }}>
        {[
          ['pending', t('sp_filter_pending', 'Pending')],
          ['public', t('sp_reviews_tab_public', 'Public')],
          ['hidden', t('sp_reviews_hidden', 'Hidden')],
          ['unsubmitted', t('sp_reviews_tab_unsubmitted', 'Unsubmitted')],
          ['all', t('all', 'All')],
        ].map(([s, label]) => (
          <button key={s} onClick={() => setStatus(s)} style={tabBtn(status === s)}>
            {label}
          </button>
        ))}
      </div>
      {err && <div style={errorBox}>{err}</div>}
      {loading
        ? <div style={empty}>{t('sp_loading_short', 'Loading…')}</div>
        : reviews.length === 0
          ? <div style={empty}>{t('sp_no_reviews_filtered', 'No {status} reviews.', { status })}</div>
          : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {reviews.map(r => (
                <div key={r.ID_NO} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: 16 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <div>
                      <strong style={{ color: '#0f172a' }}>{r.GolferName}</strong>
                      <span style={{ marginLeft: 8, fontSize: 12, color: '#64748b' }}>{r.GolferEmail}</span>
                    </div>
                    {r.Rating > 0 && <Stars n={r.Rating} />}
                  </div>
                  <div style={{ fontSize: 13, color: '#64748b', marginBottom: 8 }}>
                    {r.PackageName} · {r.CheckInDate} → {r.CheckOutDate}
                    {r.SubmittedAt && <> · {t('sp_review_submitted_at', 'submitted {date}', { date: new Date(r.SubmittedAt).toLocaleDateString() })}</>}
                  </div>
                  {r.ReviewText && <p style={{ margin: '8px 0', padding: 12, background: '#f8fafc', borderRadius: 6, fontSize: 14, color: '#1e293b', lineHeight: 1.5 }}>{r.ReviewText}</p>}
                  {r.SubmittedAt && (
                    <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                      {!r.IsPublic
                        ? <button onClick={() => moderate(r.ID_NO, 'publish')} style={primaryBtn}>{t('sp_review_publish', 'Publish')}</button>
                        : <button onClick={() => moderate(r.ID_NO, 'hide')}    style={secondaryBtn}>{t('sp_review_unpublish', 'Unpublish')}</button>}
                      {!r.IsPublic && r.SubmittedAt && (
                        <button onClick={() => moderate(r.ID_NO, 'hide')} style={{ ...secondaryBtn, color: '#dc2626', borderColor: '#fecaca' }}>{t('sp_review_reject', 'Reject')}</button>
                      )}
                    </div>
                  )}
                  {!r.SubmittedAt && (
                    <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 8 }}>{t('sp_review_invite_no_rating', 'Invite sent; no rating yet.')}</div>
                  )}
                </div>
              ))}
            </div>
          )
      }
    </ResellerShell>
  )
}

function Stars({ n }) {
  return <span style={{ color: '#f59e0b' }}>{'★'.repeat(n)}{'☆'.repeat(5 - n)}</span>
}
const tabBtn = (active) => ({ padding: '8px 16px', background: active ? '#0f172a' : 'transparent', color: active ? '#fff' : '#64748b', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' })
const errorBox = { padding: 12, background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca', borderRadius: 6, marginBottom: 16 }
const empty = { padding: 40, textAlign: 'center', color: '#64748b', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8 }
const primaryBtn = { padding: '8px 14px', background: '#0f172a', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' }
const secondaryBtn = { padding: '8px 14px', background: '#fff', color: '#475569', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13, cursor: 'pointer' }
